































import Vue from 'vue';
import { BFormGroup, BFormInput } from 'bootstrap-vue';

export default Vue.extend({
  name: 'SettingsUrl',
  components: {
    BFormGroup,
    BFormInput,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: null,
    };
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  created() {
    this.form = Object.assign({}, this.value);
  },
  methods: {
    emitNext() {
      this.$emit('onNextStep');
    },
  },
});
